<template>
	<div class="fill-height"  :class="{ 'd-flex align-center justify-center': loading }">
		<v-dialog v-model="deleteDialog" width="350">	
			<v-card class="rounded-lg pa-1">
			<v-card-title class="d-flex w-100 ms-0 pt-3 pb-1 Urbanist-font">Delete user</v-card-title>

			<v-card-text class="Urbanist-font py-0">
				Are you sure you want to delete this Task ?
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="alert-color white--text"
					@click="deleteItem()"
					:loading="submitLoading"
					class="rounded-lg text-none"
				>
					Yes
				</v-btn>

				<v-btn
					text
					@click="deleteDialog = false"
					:disabled="submitLoading"
					class="text-none"
				> 
					Cancel 
				</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>
		
		<div class="fill-height pt-2" >
			<!-- header -->
			<v-card 
				:style="!$vuetify.theme.dark ? 'box-shadow: -4px 3px 37px -3px #e8e7e76e' : null" 
				class=" card-style rounded-lg"
				:class="{
					'box': !$vuetify.theme.dark
				}"
			>
				<v-card-text class="pt-0 mt-2 pe-3">
					<v-row align="center" class="">
						<v-col cols="3">
							<bee-date-input
								v-model="date"
								:label="moment(date).format('dddd')"
								input-format-order="DD-MM-YYYY"
								append-icon="mdi-menu-right"
								@click:append="upDay(); getWorkDayByDateFilter()"
								prepend-icon="mdi-menu-left"
								@click:prepend="downDay(); getWorkDayByDateFilter()"
								dense
								class="rounded-lg"
								hide-details
								:disabled="loading"
							></bee-date-input>
						</v-col>
						<v-col cols="2" class="d-flex py-0">
							<v-icon color="primary" class=""> mdi-account </v-icon>
							<v-divider vertical class="my-4 mx-1 color" />	
							<v-autocomplete
								v-model="userIdAdded"
								label="Employee"
								:items="usersWithoutPag"
								:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
								item-value="id"
								:disabled="loading"
							/>
							<!-- @change="getWorkDayByDateFilter()" -->
						</v-col>
						<v-col cols="2" align-self="center" class="py-0 pe-0 d-flex justify-space-between">
							<div class="mx-1">
								<v-img
									v-if="!$vuetify.theme.dark"
									src="../../assets/Vectors/clock-nine (1).svg"
									width="20"
								/>
								<v-img
									v-else
									src="../../assets/Vectors/clock-nine-white.svg"
									width="20"
								/>
							</div>
							<v-divider vertical class="my-0 mx-1 color" /> 
							<v-text-field
								v-model="enterTime"
								label="Enter time"
								type="time"
								hide-spin-buttons
								
								dense
								hide-details
								class="rounded-lg time"
								:disabled="loading"
								@change="$route.params.id ? updateWorkday() : null"
							/>
						</v-col>

						<v-col cols="2" align-self="center" class="py-0 pe-0 d-flex justify-space-between">
							<div class="mx-1">
								<v-img
									v-if="!$vuetify.theme.dark"
									src="../../assets/Vectors/clock-nine (1).svg"
									width="20"
								/>
								<v-img
									v-else
									src="../../assets/Vectors/clock-nine-white.svg"
									width="20"
								/>
							</div>
							<v-divider vertical class="my-0 mx-1 color" /> 
							<v-text-field
								v-model="leaveTime"
								label="Leave time"
								type="time"
								hide-spin-buttons
								dense
								hide-details
								class="rounded-lg time"
								:disabled="loading"
								@change="$route.params.id ? updateWorkday() : null"
							/>
							
						</v-col>
						<v-col cols="auto" align-self="center" class="py-0">
							<h3> {{ (span / 60).toFixed(2) }} </h3>
						</v-col>
						<v-spacer />
						<v-col cols="auto" align-self="center">
							<v-btn
								v-if="$route.params.id"
								width="50"
								color="success white--text"
								class="text-none"
								@click="updateWorkday()"
								:disabled="loading"
							>
								Save
							</v-btn>
						</v-col>
						<v-col cols="auto" class="d-flex justify-end  py-0 pe-0 mt-0 mr-minus-5 ">
							<!--  -->
							<v-btn
								small
								:color="$route.params.id ? 'primary' : 'success-light white--text'"
								height="80"
								width="100"
								elevation="0"
								class="text-none rounded-r-lg mt-minus-5"
								@click="submit"
								:disabled="
									(leaveTime === null && !$route.params.id) || 
									enterTime === null || 
									userIdAdded === null
								"
							>
								<div class="d-flex flex-column align-center text-center">
									<v-icon class="mb-1"> {{ !$route.params.id ? 'mdi-content-save' : 'mdi-arrow-left-thin' }} </v-icon>
									<span class="line-h-1-3"> {{ !$route.params.id ? 'Create' : 'Back to' }} <br /> 
										{{ !$route.params.id ? 'WorkDay' : 'All Tasks' }} </span>
								</div>

							</v-btn>
						</v-col>    
					</v-row>
				</v-card-text>
			</v-card>
			
			<!-- table -->
			<v-card
				:style="!$vuetify.theme.dark ? 'box-shadow: -4px 3px 37px -3px #e8e7e76e' : null"
				:height="$vuetify.breakpoint.height - 280"
				class="w-100 h-100 rounded-lg mt-4 box"
			>
				<v-card-text class="py-0 px-0 rounded-lg">
					<!-- table -->
					<bee-handy-smart-table
						v-model="tableInputs"
						ref="table"
						:items="tasks"
						:headers="headers"
						class="mt-3"
						table-class="elevation-0"
						:show-add-row="$route.params.id && (!submitLoading && !loading)"
						@keypress.enter="isEditItem ? editItem() : addItem()"
						zebra
						pagination-on-scroll
						:height="$vuetify.breakpoint.height - 250"
						editable-rows
						:reset-edit.sync="resetEdit"
						hot-inputs
						@change-end="getDuration()"
						@change-start="getDuration()"
						:loading="submitLoading || loading"
						fixed-header
						:items-per-page="-1"
						dense
					>
						<template v-slot:input.projectId="{ on ,attr }">
							<v-autocomplete
								:items="projectBrief"
								item-text="name"
								item-value="id"
								dense
								hide-details
								v-on="on"   
								v-bind="attr"
							/>
						</template>

						<template v-slot:input.workFromHome="{ on, attr }">
							<v-checkbox
								v-model="tableInputs.workFromHome"
								v-on="on"
								v-bind="attr"
								class="d-flex align-center mt-0"
								hide-details
							/>
						</template>
							
						<!-- start time -->
						<template v-slot:input.start="{ on, attr }">
							<v-text-field
								type="time" 
								v-on="on"
								v-bind="attr"
							/>
						</template>

						<!-- end time -->
						<template v-slot:input.end="{ on, attr }">
							<v-text-field
								type="time" 	
								v-on="on"
								v-bind="attr"
							/>
						</template>

						<template v-slot:input.durationInMinute="{ on, attr }">
							<v-text-field
								readonly
								v-on="on"
								v-bind="attr"
							/>
						</template>

						<template v-slot:input.tags="{ on ,attr }">
							<v-autocomplete
								:items="tags"
								item-text="name"
								item-value="id"
								dense
								hide-details
								v-on="on"   
								v-bind="attr"
								multiple
							/>
						</template>

						<template v-slot:item.actions="{ index, item }">
							<div class="d-flex">
								<v-btn 
									icon 					
									@click="
										taskId = item.id;
										$refs.table.resetInputs(); 
										$refs.table.activeEditForRow(index); 
										setRowIndex({ index })
									"
									:disabled="submitLoading || loading"
								>
									<v-icon color="edit-color"> mdi-pencil </v-icon>
								</v-btn>
							</div>
						</template>

						<template v-slot:no-input.actions>
							<div class="d-flex align-center">
								<v-btn
									v-if="isEditItem"
									small
									color="white--text edit-color text-none"
									@click="editItem()"
									:disabled="submitLoading || loading"
								>
									Save edit
								</v-btn>
								<v-btn
									:color="!isEditItem ? 'success-light': 'alert-color'"
									@click="!isEditItem ? addItem() : isEditItem = false ;$refs.table.resetEdit()"
									class="text-none rounded-lg white--text"
									:icon="isEditItem"
									:disabled="submitLoading || loading"
								>
									<v-icon>mdi-{{!isEditItem ? 'plus' : 'close-circle-outline'}}</v-icon>
									{{ !isEditItem ? 'Add Task' : '' }}
								</v-btn>
							</div>
						</template>

					</bee-handy-smart-table>

					<div
						class="footer d-flex primary-light align-item-center rounded-lg rounded-t-0 py-2 px-3"
					>
						<v-row align="center">
							<v-col class="py-0" align-self="center">
								<span class="fw-bold">
									Check in: {{ checkIn !== null ? moment(checkIn).format('hh:mm a') : '-' }} 
								</span>

							</v-col>

							<v-col class="py-0" align-self="center">
								<span class="fw-bold"> Check out: {{ checkOut !== null ? moment(checkOut).format('hh:mm a') : '-' }} </span>
							</v-col>

							<v-col class="py-0" align-self="center">
								Diff: {{ (diffInOut / 60).toFixed(2) }}
							</v-col>

							<v-col class="py-0" align-self="center">
								<!-- <span class="text-end">  -->
								<span class="Righteous-font text--color mx-3"> Total Hours </span>
								<span class="title text--color fw-bold"> {{ totalHours }} h </span>
								<!-- </span> -->
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import rules from '@/helper/validation rules.js'
export default {
	data () {
		return {
			tt: null,
			show: false,
			yes: false,
			submitLoading: false,
			enterTime: null,
			leaveTime: null,
			tasks: [],
			time: null,
			taskId: null,
			rowEditIndex: null,
			isEditItem: false,
			tableInputs: {
				tagIds: []
			},
			loading: false,
			status: [
				{
					name: 'included',
					id: '0'
				},
				{
					name: 'Not included',
					id: '1'
				}
			],
			resetEdit: false,
			workDay: { tasks: [] },
			lockDay: false,
			date: this.moment().format('YYYY-MM-DD'),
			userIdAdded: null,
			// projectBrief: [],
			deleteDialog: false,
			span: 0,
			checkIn: 0,
			checkOut: 0,
			diffInOut: 0,
			rules
		}
	},
	computed: {
		...mapState({
			tags: state => state.tags.tags,
			employeeId: state => state.auth.self.employeeId,
			plannedTask: state => state.plan.plannedTask,
			userId: state => state.auth.self.id,
			myPlanActive: state => state.plan.myPlanActive,
			plannedTaskByProject: state => state.plan.plannedTaskByProject,
			usersWithoutPag: state => state.users.usersWithoutPag,
			projectBrief: state => state.projects.projectsBrief
		}),

		...mapGetters({
			getEmployeeById: 'users/getEmployeeById',
			getTagById: 'tags/getTagById'
		}),

		headers () {
			const headers = [
				{	
					text: 'Project Name',
					name: 'projectId',
					value: 'projectId',
					setValueExpr: val => this.projectBrief.find(c => c.id === val)?.name,
					class: 'text--color',
					sortable: false
				},
				{
					text: 'Descraption',
					name: 'planId',
					value: 'description',
					class: 'text--color',
					sortable: false,
					inputRules: [val => val !== null || '-']
				},
				{	
					text: 'Task No',
					name: 'taskNo',
					value: 'taskNo',
					class: 'text--color',
					type: 'number',
					sortable: false,
					width: '10%'
				},
				{
					text: 'Start',
					name: 'start',
					value: 'start',
					setValueExpr: val => val
						? (Number(val.split(':')[0]) >= 12)
							? (Number(val.split(':')[0]) > 12 ? (val.split(':')[0]) - 12 : val.split(':')[0]) + ':' + val.split(':')[1] + ' pm'
							: val.split(':')[0] + ':' + val.split(':')[1] + ' am'
						: '-',
					class: 'text--color',
					noNotAvailableText: true,
					width: 120
				},
				{
					text: 'End',
					name: 'end',
					value: 'end',
					setValueExpr: val => val 
						? (Number(val.split(':')[0]) >= 12)
							? (Number(val.split(':')[0]) > 12 ? (val.split(':')[0]) - 12 : val.split(':')[0]) + ':' + val.split(':')[1] + ' pm'
							: val.split(':')[0] + ':' + val.split(':')[1] + ' am'
						: '-',
					class: 'text--color',
					noNotAvailableText: true
				},
				// {
				// 	text: 'Duration',
				// 	name: 'durationInMinute',
				// 	value: 'durationInMinute',
				// 	setValueExpr: val => {
				// 		if (val) {
				// 			const hoursDifference = val / 60; 
				// 			return `${Math.floor(hoursDifference)}:${Math.floor((hoursDifference - Math.floor(hoursDifference)) * 60).toString().padStart(2, 0)}`
				// 		} else {
				// 			return '-'
				// 		}
				// 	},
				// 	class: 'text--color',
				// 	noNotAvailableText: true
				// },
				{
					text: 'Duration',
					name: 'durationInMinute',
					value: 'durationInMinute',
					setValueExpr: val => {
						if (val > 0) {
							const hoursDifference = val / 60; 
							return `${Math.floor(hoursDifference)}:${Math.ceil((hoursDifference - Math.floor(hoursDifference)) * 60).toFixed(0).padStart(2, 0)}`
						} else {
							return val
						}
					},
					class: 'text--color',
					width: 120
					// noInput: true
				},
				{
					text: 'Tags',
					name: 'tags',
					value: 'tagIds',
					setValueExpr: val => val.length ? val.map(c => this.tags.find(i => i.id === c)?.name).join(',') : '-',
					class: 'text--color',
					sortable: false
				},
				{
					text: 'Home',
					name: 'workFromHome',
					value: 'workFromHome',
					setValueExpr: val => val === true ? 'Yes' : 'No',
					class: 'text--color',
					type: 'Boolean',
					sortable: false
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					sortable: false,
					noInput: true
				}
			]
			return headers
		},

		totalHours () {	
			const hours = Number(((this.tasks?.map(c => c.durationInMinute).reduce((x, y) => { return (x + y) }, 0))))				
			return Math.floor(hours / 60) + ':' + Math.ceil(((hours / 60) - Math.floor((hours / 60))) * 60).toFixed(0).padStart(2, 0)
		}
	},
	methods: {
		moment,

		addItem () {
			if (this.$refs.table.validate()) {
				this.submitLoading = true
				this.$store.dispatch('tasks/create', { 
					description: this.tableInputs.planId.content ? this.tableInputs.planId.content : this.tableInputs.planId,
					projectId: this.tableInputs.projectId,
					taskNo: this.tableInputs.taskNo ? this.tableInputs.taskNo : 0, 
					start: (this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.start),
					end: (this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.end),
					planId: this.tableInputs.planId.id,
					// durationInMinute: Math.round((this.tableInputs.durationInMinute) * 60) , 
					durationInMinute: 0,
					workdayId: this.$route.params.id,	
					// isApproved, 
					tagIds: this.tableInputs.tags ? this.tableInputs.tags : [],
					workFromHome: Boolean(this.tableInputs.workFromHome)
				}).then(() => {
					// get workday by id
					this.loading = true
					this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
						this.workDay = data
						this.tasks = []
						this.tasks = this.workDay.tasks.map(c => ({ ...c, start: c.start.split('T')[1], end: c.end.split('T')[1] }))
					}).finally(() => {
						this.loading = false
					})
					this.$refs.table.resetInputs();
				}).finally(() => {
					this.submitLoading = false
				})
			}
		},

		editItem () {
			this.workDay.tasks[this.rowEditIndex].projectId = this.tableInputs.projectId
			this.workDay.tasks[this.rowEditIndex].taskNo = this.tableInputs.taskNo ? this.tableInputs.taskNo : 0
			this.workDay.tasks[this.rowEditIndex].description = this.tableInputs.description
			this.workDay.tasks[this.rowEditIndex].planId = this.tableInputs.planId
			this.workDay.tasks[this.rowEditIndex].start = (this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.start)
			this.workDay.tasks[this.rowEditIndex].end = (this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.end)
			this.workDay.tasks[this.rowEditIndex].durationInMinute = Math.round((this.tableInputs.durationInMinute) * 60)

			this.workDay.tasks[this.rowEditIndex].workFromHome = this.tableInputs.workFromHome
			this.resetEdit = true
			// this.resetTableInputs()
			this.$refs.table.resetEdit()
			this.isEditItem = false
			this.resetInputsFocus = true
			this.$store.dispatch('tasks/update', {
				id: this.taskId, 
				// this.tableInputs.planId ? this.tableInputs.planId : this.tableInputs.planId.content,
				description: this.workDay.tasks[this.rowEditIndex].planId.content ? this.workDay.tasks[this.rowEditIndex].planId.content : this.workDay.tasks[this.rowEditIndex].planId, 
				projectId: this.workDay.tasks[this.rowEditIndex].projectId, 
				taskNo: this.workDay.tasks[this.rowEditIndex].taskNo, 
				planId: this.workDay.tasks[this.rowEditIndex].planId.id, 
				start: this.workDay.tasks[this.rowEditIndex].start, 
				end: this.workDay.tasks[this.rowEditIndex].end, 
				durationInMinute: this.workDay.tasks[this.rowEditIndex].durationInMinute, 
				workdayId: this.$route.params.id, 
				workFromHome: this.workDay.tasks[this.rowEditIndex].workFromHome, 
				tagIds: this.workDay.tasks[this.rowEditIndex].tagIds
			}).then(() => {
				// get workday by id
				this.loading = true
				this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
					this.workDay = data
					this.tasks = []
					this.tasks = this.workDay.tasks.map(c => ({ ...c, start: c.start.split('T')[1], end: c.end.split('T')[1] }))
					this.span = data.officeHours
				}).finally(() => {
					this.loading = false
				})
			}).finally(() => {
				this.taskId = null
			})
		},
		
		deleteItem () {
			this.loading = true
			this.submitLoading = true
			this.$store.dispatch('tasks/delete', { id: this.taskId }).then(() => {
				this.loading = true
				this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
					this.workDay = data
					this.tasks = this.workDay.tasks.map(c => ({ ...c, start: c.start.split('T')[1], end: c.end.split('T')[1] }))
				}).finally(() => {
					this.loading = false
				})
			}).finally(() => {
				this.loading = false
				this.submitLoading = false
				this.deleteDialog = false
			})
		},

		setRowIndex (rowData) {
			this.rowEditIndex = rowData.index
			this.isEditItem = true
			this.$nextTick(() => {
				this.$refs.table.resetInputsFocus()
			})
		},

		getDuration () {
			let start = null
			let end = null
	
			start = this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.start
			
			end = this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.end
			const hoursDifference = moment(end).diff(start, 'm') / 60;
			this.tableInputs.durationInMinute =
				`${Math.floor(hoursDifference)}:${((hoursDifference - Math.floor(hoursDifference)) * 60).toFixed(0)}`
			console.log(`${Math.floor(hoursDifference)}:${((hoursDifference - Math.floor(hoursDifference)) * 60).toFixed(0)}`)
		},

		createWorkDay () {
			this.loading = true
			this.$store.dispatch('workDay/createWorkDayFromAdministrative', {
				date: this.date,
				enterTime: this.moment(this.date).format('YYYY-MM-DD') + 'T' + this.enterTime,
				leaveTime: this.moment(this.date).format('YYYY-MM-DD') + 'T' + this.leaveTime,
				userId: this.userIdAdded,
				taskIds: [],
				notes: '',
				startDate: this.moment(this.date).format('YYYY-MM-DD') + 'T' + '10:00:00',
				endDate: this.moment(this.date).format('YYYY-MM-DD') + 'T' + '19:00:00'
			}).then((data) => {
				this.$router.replace({
					name: 'add-papper-task',
					params: {
						id: data
					}
				})
			}).finally(() => {
				this.loading = false
			})
		},
		
		updateWorkday () {
			this.loading = true
			this.submitLoading = true
			this.$store.dispatch('workDay/update', { 
				id: this.$route.params.id, 
				date: this.date,
				enterTime: this.enterTime !== null ? this.moment().format('YYYY-MM-DD') + 'T' + this.enterTime : null,
				leaveTime: this.leaveTime !== null ? this.moment().format('YYYY-MM-DD') + 'T' + this.leaveTime : null,
				startDate: this.workDay.startDate,
				endDate: this.moment().format('YYYY-MM-DD') + 'T' + this.moment().format().split('T')[1].split('+')[0],
				userId: this.userIdAdded,
				taskIds: this.tasks.map(c => c.id),
				notes: ''
			}).then(() => {
				this.loading = true
				this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
					this.workDay = data
					this.tasks = []
					this.tasks = this.workDay.tasks.map(c => ({ ...c, start: c.start.split('T')[1], end: c.end.split('T')[1] }))
					this.span = data.officeHours
				}).finally(() => {
					this.loading = false
				})
			}).finally(() => {
				this.loading = false
				this.submitLoading = false		
			})
		},

		submit () {
			console.log(this.$route.params.id)
			if (!this.$route.params.id) {
				this.createWorkDay()
			} else {
				this.$router.replace({
					name: 'task-papers'
				})
			}
		},
		upDay () {
			this.date = this.moment(this.date).add(1, 'day').format('YYYY-MM-DD')
			return this.date
		},
		downDay () {
			this.date = this.moment(this.date).subtract(1, 'day').format('YYYY-MM-DD')
			return this.date
		},

		getWorkDayByDateFilter () {
			this.submitLoading = true
			this.$store.dispatch('workDay/fetchAll', {
				userIds: [this.userIdAdded], 
				fromDate: this.date, 
				toDate: this.date,
				projectIds: []
			}).then((data) => {
				this.tasks = []
				if (data.data.length === 0) {
					if (this.$route.name !== 'add-papper-task') {
						this.$router.push({
							name: 'add-papper-task'
						})
					} else {
						const currentParams = this.$route.params;
						const newParams = { param1: null, param2: null };

						if (JSON.stringify(currentParams) !== JSON.stringify(newParams)) {
							this.$router.push({ 
								name: 'add-papper-task',
								params: newParams 
							});
						}
					}
				} else {
					if (data.data[0].id !== this.$route.params.id) {
						this.$router.push({
							params: {
								id: data.data[0].id
							}
						})
					}
					this.tasks = data.data[0].tasks?.map(c => ({ ...c, start: c.start?.split('T')[1], end: c.end?.split('T')[1] }))
					this.leaveTime = data.data[0].leaveTime !== null ? data.data[0].leaveTime.split('T')[1] : null
					this.enterTime = data.data[0].enterTime !== null ? data.data[0].enterTime.split('T')[1] : null
					this.span = data.data[0].officeHours
					this.checkIn = data.data[0].startDate
					this.checkOut = data.data[0].endDate
					this.diffInOut = data.data[0].workTime
				}
			}).finally(() => {
				this.submitLoading = false
			})
		}
	},

	created () {
		this.loading = true
		Promise.all([
			this.$store.dispatch('tags/fetchAll').then(() => {
				// console.log(this.tags)
			}),
			this.$store.dispatch('projects/fetchProjectBrief').then((data) => {
				// this.projectBrief = data
			}),
			
			this.$store.dispatch('plan/fetchActivePlanForUser', { userId: this.userId }).then((data) => {
				if (data.length !== 0) {
					this.$store.dispatch('plan/fetchPlannedTask', { planId: data[0].id })
				}
			}),
			!this.usersWithoutPag.length ? this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true }) : null,

			this.$route.params.id 
				? this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
					this.workDay = data
					this.userIdAdded = data?.userId
					this.date = this.moment(data.date).format('YYYY-MM-DD')
					this.tasks = this.workDay.tasks?.map(c => ({ ...c, start: c.start?.split('T')[1], end: c.end?.split('T')[1] }))
					this.span = data.officeHours
					this.checkIn = data.startDate
					this.checkOut = data.endDate
					this.diffInOut = data.workTime
					this.leaveTime = data.leaveTime ? data.leaveTime?.split('T')[1] : null
					this.enterTime = data.enterTime ? data.enterTime?.split('T')[1] : null
				})
				: null
		]).finally(() => {
			this.loading = false 
		})
	}
}
</script>

<style scoped>
.fs-12 {
    font-size: 12px;
}
.card {
    width: 250px;
    height: 65px;
}
.w-100 {
    width: 100%;
}
.h-100 {
    height: 100%;
}

.box {
	box-shadow: -4px 3px 37px -3px #e8e7e76e
}
.footer {
	width: 100%; 
	height: 50px; 
}
</style>
<style>
input[type="time"]::-webkit-calendar-picker-indicator { display: none; }
.bee-handy-table--zebra-color:nth-of-type(odd) {
	background-color: #f5ecc966
}
td {
	font-family: 'Urbanist' !important;
}
input:focus {
	border: none !important;
}

</style>

<style>
* {
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

</style>
